import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=4743bd39&scoped=true&"
import script from "./Heading.vue?vue&type=script&setup=true&lang=js&"
export * from "./Heading.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Heading.vue?vue&type=style&index=0&id=4743bd39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4743bd39",
  null
  
)

export default component.exports